import { type TRootState } from 'lib/stores';

export const listViewStateSelector = (state: TRootState) => state.ui.isListView;

export const sidebarCollapsedStateSelector = (state: TRootState) =>
  state.ui.isSidebarCollapsed;

export const selectedMenuKeysSelector = (state: TRootState) =>
  state.ui.selectedMenuKeys;

export const appPrimaryColorSelector = (state: TRootState) =>
  state.ui.appPrimaryColor;

export const darkModeSelector = (state: TRootState) => state.ui.darkMode;
